import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgChevronDown = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m18.76 9.58-6.193 5.933c-.207.175-.402.247-.567.247a.82.82 0 0 1-.538-.217L5.24 9.58c-.31-.295-.321-.817-.023-1.099a.774.774 0 0 1 1.099-.023L12 13.906l5.684-5.444a.774.774 0 0 1 1.099.023c.298.278.288.8-.023 1.095"
    }));
export default SvgChevronDown;
